import { handleActions } from 'redux-actions';
import actions from 'state/downloads/actionCreators';

const defaultState = {
  isSubmitting: false,
  isRequestSuccessful: null,
};

const reducer = handleActions(
  {
    [actions.setDownloadRequestSuccessful]: (
      state,
      { payload: { success } }
    ) => ({
      ...state,
      isRequestSuccessful: success,
    }),
    [actions.setDownloadSubmitting]: (state, { payload: { submitting } }) => ({
      ...state,
      isSubmitting: submitting,
    }),
  },
  defaultState
);

export default reducer;
